export const eventsData = [
    {
      id: 1,
      name: 'AGM 2023',
      images: [
        { id: 1, src: './Images/Gallery/AGM 2023/1.jpg', alt: 'Image 1' },
        { id: 2, src: './Images/Gallery/AGM 2023/2.jpg', alt: 'Image 2' },
      ],
      description: 'This was our AGM for the 2023/24 academic year. Congrats to the new committee!',
    },
    {
      id: 2,
      name: 'Brainfood (Coffee Morning)',
      images: [
        { id: 3, src: './Images/Gallery/Brainfood/1.jpg', alt: 'Image 3' },
        { id: 4, src: './Images/Gallery/Brainfood/2.jpg', alt: 'Image 4' },
      ],
      description: 'These are some pictures from our Brainfood mornings. These are coffee mornings where we provide free coffee and snacks to students, usually at lunchtime in the Fitzgerald Library. These are typically weekly, but the specific day will vary from year to year so check your emails!',
    },
    {
      id: 3,
      name: 'Italy Trip 2023',
      images: [
        { id: 5, src: './Images/Gallery/Italy Trip/1.jpg', alt: 'Image 5' },
        { id: 6, src: './Images/Gallery/Italy Trip/2.jpg', alt: 'Image 6' },
        { id: 7, src: './Images/Gallery/Italy Trip/3.jpg', alt: 'Image 7' },
        { id: 8, src: './Images/Gallery/Italy Trip/4.jpg', alt: 'Image 8' },
      ],
      description: 'This was our big trip for the 2022/23 academic year. We went to Italy and visited the INFN LABEC lab in Florence and the European Gravitational Observatory in Pisa, Che bello!',
    },
    
    {
        id: 4,
        name: 'CERN 2022',
        images: [
            { id: 9, src: './Images/Gallery/CERN/1.jpeg', alt: 'Image 9' },
            { id: 10, src: './Images/Gallery/CERN/2.jpeg', alt: 'Image 10' },
            { id: 11, src: './Images/Gallery/CERN/3.jpeg', alt: 'Image 11' },
            { id: 12, src: './Images/Gallery/CERN/4.jpeg', alt: 'Image 12' },
            { id: 13, src: './Images/Gallery/CERN/5.jpeg', alt: 'Image 13' },
            { id: 14, src: './Images/Gallery/CERN/6.jpeg', alt: 'Image 14' },
            { id: 15, src: './Images/Gallery/CERN/7.jpeg', alt: 'Image 15' },
            { id: 16, src: './Images/Gallery/CERN/8.jpeg', alt: 'Image 16' },
            { id: 17, src: './Images/Gallery/CERN/9.jpeg', alt: 'Image 17' },
            { id: 18, src: './Images/Gallery/CERN/10.jpeg', alt: 'Image 18' },
            { id: 19, src: './Images/Gallery/CERN/11.jpeg', alt: 'Image 19' },
            { id: 20, src: './Images/Gallery/CERN/12.jpeg', alt: 'Image 20' },
            { id: 21, src: './Images/Gallery/CERN/13.jpeg', alt: 'Image 21' },
        ],
        description: "This was our big trip for the 2021/22 academic year. We went to CERN in Geneva, Switzerland, saw the sites, and marvelled at the enormous particle physics going on! Photo credit: Mark O'Neill, Ruaidhrí Campion",
    },

    {
        id: 5,
        name: 'MathsPhys Careers Fair 2022',
        images: [
            { id: 22, src: './Images/Gallery/Careers Fair 2022/2.jpg', alt: 'Image 22' },
            { id: 25, src: './Images/Gallery/Careers Fair 2022/4.jpg', alt: 'Image 25' },
            { id: 23, src: './Images/Gallery/Careers Fair 2022/1.jpg', alt: 'Image 23' },
            { id: 24, src: './Images/Gallery/Careers Fair 2022/3.jpg', alt: 'Image 24' },
        ],
        description: "This was the MathsPhys Careers Fair we ran in September alongside Mathsoc and TPSA. With 250+ students attending the fair and 16 companies/institutions that presented (as well as 1 virtual!), we were delighted to hear overwhelming positive feedback from both students and presenters. Attending the Fair were Accenture, Cellix, Cenergise, EY, Gaingels, Grant Thornton Ireland, IBM, ICFO, Irish Centre for High-End Computing ICHEC, Institute of Science and Technology Austria, KPMG Ireland, Met Éireann, Susquehanna International Group, LLP (SIG), Tyndall National Institute, Vodafone, and Children's Health Ireland.",
    },

    {
        id: 6,
        name: 'Talks by Prof Brian Espey and Prof Luke Drury (2015/2016)',
        images: [
            { id: 26, src: './Images/Gallery/Talks by Prof Brian Espey and Prof Luke Drury/1.jpeg', alt: 'Image 26' },
            { id: 27, src: './Images/Gallery/Talks by Prof Brian Espey and Prof Luke Drury/2.jpeg', alt: 'Image 27' },
            { id: 28, src: './Images/Gallery/Talks by Prof Brian Espey and Prof Luke Drury/3.jpeg', alt: 'Image 28' },
            { id: 29, src: './Images/Gallery/Talks by Prof Brian Espey and Prof Luke Drury/4.jpeg', alt: 'Image 29' },
            { id: 30, src: './Images/Gallery/Talks by Prof Brian Espey and Prof Luke Drury/5.jpeg', alt: 'Image 30' },
            { id: 31, src: './Images/Gallery/Talks by Prof Brian Espey and Prof Luke Drury/6.jpeg', alt: 'Image 31' },
            { id: 32, src: './Images/Gallery/Talks by Prof Brian Espey and Prof Luke Drury/7.jpeg', alt: 'Image 32' },
            { id: 33, src: './Images/Gallery/Talks by Prof Brian Espey and Prof Luke Drury/8.jpeg', alt: 'Image 33' },
            { id: 34, src: './Images/Gallery/Talks by Prof Brian Espey and Prof Luke Drury/9.jpeg', alt: 'Image 34' },
            { id: 35, src: './Images/Gallery/Talks by Prof Brian Espey and Prof Luke Drury/10.jpeg', alt: 'Image 35' },
        ],
        description: '',
    },

  ];
  